export class EquipmentBreakdown {
    id!: string
    equipment!: string
    description!: string
    date!: Date
    completedDate!: Date | undefined
    workOrder!: string
    mechanicId!: string
    mechanicHrRef!: string

    imageUrls!: string[]
}
